console.log('🔍 Wishlist reposition script loaded!');

var wishlistMoved = false; // 防止重复执行

function repositionWishlistButton() {
  console.log('🚀 Trying to reposition wishlist button...');
  console.log('Window width:', window.innerWidth);
  
  var isMobile = window.innerWidth < 750;
  
  var wishlistSelectors = [
    '#shopify-block-Ae115eTac21VWHp4K__growave_loyalty_wishlist_block_product_fave_button_MHGrT6',
    '.gw-wl-add-to-wishlist-product-page-widget',
    '[class*="growave"]',
    '[class*="wishlist"]'
  ];
  
  var wishlistWidget = null;
  
  for (var i = 0; i < wishlistSelectors.length; i++) {
    var element = document.querySelector(wishlistSelectors[i]);
    if (element) {
      wishlistWidget = element.closest('.product__block') || element.closest('.shopify-block') || element;
      if (wishlistWidget) {
        console.log('📍 Found wishlist widget with selector:', wishlistSelectors[i]);
        break;
      }
    }
  }
  
  console.log('📍 Wishlist widget:', wishlistWidget);
  
  if (isMobile) {
    // 移动端：移动到 sticky bar
    var stickyContainer = document.querySelector('#sticky-wishlist-container');
    console.log('📱 Mobile - Sticky container:', stickyContainer);
    
    if (wishlistWidget && stickyContainer && !wishlistMoved) {
      // 检查是否已经有 wishlist 按钮在 sticky bar 中
      if (stickyContainer.querySelector('.gw-wl-add-to-wishlist-product-page-widget')) {
        console.log('⚠️ Wishlist already in sticky bar, skipping...');
        wishlistMoved = true;
        return true;
      }
      
      console.log('✅ Moving wishlist to sticky bar (mobile)...');
      
      // 克隆 wishlist 按钮（不移动原始元素）
      var wishlistClone = wishlistWidget.cloneNode(true);
      stickyContainer.appendChild(wishlistClone);
      
      wishlistMoved = true;
      console.log('✅ Wishlist added to sticky bar!');
      return true;
    }
  } else {
    // 桌面端：移动到 Add to Cart 旁边
    var buttonContainer = document.querySelector('.product-form__buttons:not(.sticky-atc-bar .product-form__buttons)');
    console.log('💻 Desktop - Button container:', buttonContainer);
    
    if (wishlistWidget && buttonContainer && !wishlistMoved) {
      // 检查是否已经在按钮容器中
      if (buttonContainer.contains(wishlistWidget)) {
        console.log('⚠️ Wishlist already in button container, skipping...');
        wishlistMoved = true;
        return true;
      }
      
      console.log('✅ Moving wishlist button (desktop)...');
      
      buttonContainer.appendChild(wishlistWidget);
      buttonContainer.classList.add('has-wishlist-button');
      wishlistWidget.classList.add('wishlist-in-button-row');
      
      wishlistMoved = true;
      console.log('✅ Wishlist button moved successfully!');
      return true;
    }
  }
  
  console.log('❌ Could not find required elements or already moved');
  return false;
}

function waitForGrowave() {
  console.log('⏳ Waiting for Growave to load...');
  
  var observer = new MutationObserver(function(mutations, obs) {
    if (wishlistMoved) {
      obs.disconnect();
      return;
    }
    
    var growaveElement = document.querySelector('.gw-wl-add-to-wishlist-product-page-widget');
    
    if (growaveElement) {
      console.log('✅ Growave element detected!');
      obs.disconnect();
      
      setTimeout(function() {
        repositionWishlistButton();
      }, 300);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  setTimeout(function() {
    observer.disconnect();
    console.log('⏱️ Observer timeout');
  }, 10000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    if (!repositionWishlistButton()) {
      waitForGrowave();
    }
  });
} else {
  if (!repositionWishlistButton()) {
    waitForGrowave();
  }
}

// 只执行一次延迟尝试
setTimeout(function() {
  if (!wishlistMoved) {
    repositionWishlistButton();
  }
}, 2000);